import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [{
    path: '/Home',
    name: 'Home',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/Home.vue')
  },
  {
    path: '/',
    name: 'Dashboard',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/Login.vue')
  },
  {
    path: '/users',
    name: 'Users',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/user/users.vue')
  },
  {
    path: '/add-user',
    name: 'AddUser',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/user/upsertUser.vue')
  },
  {
    path: '/update-user/:id',
    name: 'UpdateUser',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/user/upsertUser.vue')
  },
  {
    path: '/change-password/:id',
    name: 'ChangePassword',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/user/changePassword.vue')
  },
  {
    path: '/tankers',
    name: 'Tankers',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/tanker/list.vue')
  },
  {
    path: '/notification',
    name: 'Notifications',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/notifications.vue')
  },
  {
    path: '/add-tanker',
    name: 'AddTanker',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/tanker/upsert.vue')
  },
  {
    path: '/update-tanker/:id',
    name: 'UpdateTanker',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/tanker/upsert.vue')
  },
  {
    path: '/dbs-cascade',
    name: 'DbsCascade',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/dbsCascade/list.vue')
  },
  {
    path: '/add-dbs-cascade',
    name: 'AddDbsCascade',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/dbsCascade/upsert.vue')
  },
  {
    path: '/update-dbs-cascade/:id',
    name: 'UpdateDbsCascade',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/dbsCascade/upsert.vue')
  },
  {
    path: '/view-chart',
    name: 'ViewChart',
    meta: { transition: 'slide-left' },
    component: () =>
      import('@/views/analytics/AnalyticsHome.vue')
  },
  {
    path: '/storage-tank',
    name: 'StorageTank',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/storageTank/list.vue')
  },
  {
    path: '/add-storage-tank',
    name: 'AddStorageTank',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/storageTank/upsert.vue')
  },
  {
    path: '/update-storage-tank/:id',
    name: 'UpdateStorageTank',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/storageTank/upsert.vue')
  },
  {
    path: '/vehicle-inspection-update/:vehicleId',
    name: 'VehicleInspection',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/vehicleInspection.vue')
  },
  {
    path: '/vehicle-inspection-update/:vehicleId/:orderId/:stepId',
    name: 'VehicleInspectionView',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/vehicleInspection.vue')
  },
  {
    path: '/vehicle-inspection-pdf/:vehicleId/:orderId/:stepId',
    name: 'VehicleInspectionView1',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/VehicleInspectionInPdf.vue')
  },
  {
    path: '/edit-trip-driver/:vehicleId/:orderId/:stepId',
    name: 'EditTripDriver',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/editTripDriver.vue')
  },
  {
    path: '/edit-trip/:id',
    name: 'editTrip',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/editTrip.vue')
  },
  {
    path: '/locations',
    name: 'Locations',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/location/list.vue')
  },
  {
    path: '/add-location',
    name: 'AddLocation',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/location/upsert.vue')
  },
  {
    path: '/update-location/:id',
    name: 'UpdateLocation',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/location/upsert.vue')
  },
  {
    path: '/geo-area',
    name: 'GeograhicalArea',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/geograhicalArea/list.vue')
  },
  {
    path: '/add-geo-area',
    name: 'AddGeograhicalArea',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/geograhicalArea/upsert.vue')
  },
  {
    path: '/update-geo-area/:id',
    name: 'UpdateGeograhicalArea',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/geograhicalArea/upsert.vue')
  },
  {
    path: '/geo-area-view/:id',
    name: 'ViewGeograhicalArea',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/geograhicalArea/view.vue')
  },
  {
    path: '/location-view/:id',
    name: 'ViewLocation',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/location/view.vue')
  },
  {
    path: '/transporters',
    name: 'Transporters',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/transporter/list.vue')
  },
  {
    path: '/add-transporter',
    name: 'AddTransporter',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/transporter/upsert.vue')
  },
  {
    path: '/update-transporter/:id',
    name: 'UpdateTransporter',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/transporter/upsert.vue')
  },
  {
    path: '/scada-simulator',
    name: 'ScadaData',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/scada/list.vue')
  },
  {
    path: '/trip-utilization-report',
    name: 'TripUtilizationReport',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/misReports/tripUtilizationList.vue')
  },
  {
    path: '/lng-dispatch-report',
    name: 'LNGDispatchReport',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/misReports/lngDispatchTripReport.vue')
  },
  {
    path: '/cng-dispatch-report',
    name: 'CNGDispatchReport',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/misReports/cngDispatchTripReport.vue')
  },
  {
    path: '/driver-report',
    name: 'DriverReport',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/misReports/driverReport.vue')
  },
  {
    path: '/track-trip',
    name: 'TrackOrder',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/TrackTrip.vue')
  },
  {
    path: '/unauth-track-trip',
    name: 'unauthTrackOrder',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/UnauthTrackTrip.vue')
  },
  {
    path: '/vehicle-utilization-report',
    name: 'VehicleUtilizationReport',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/misReports/vehicleUtilizationList.vue')
  },
  {
    path: '/time-utilization-report',
    name: 'timeUtilizationReport',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/misReports/timeUtilizationList.vue')
  },
  {
    path: '/add-scada-simulator-data',
    name: 'AddScadaData',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/scada/upsert.vue')
  },
  {
    path: '/update-scada-simulator-data/:id',
    name: 'UpdateScadaData',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/scada/upsert.vue')
  },
  {
    path: '/Tanker-vehicles',
    name: 'Vehicles',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/vehicle/tankerList.vue')
  },
  {
    path: '/MCV-vehicles',
    name: 'McvVehicles',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/vehicle/mcvList.vue')
  },
  {
    path: '/add-vehicle/:type',
    name: 'AddVehicle',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/vehicle/upsert.vue')
  },
  {
    path: '/update-vehicle/:type/:id',
    name: 'UpdateVehicle',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/vehicle/upsert.vue')
  },
  {
    path: '/vehicle-view/:id',
    name: 'VehicleView',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/vehicle/view.vue')
  },
  {
    path: '/drivers',
    name: 'Drivers',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/driver/list.vue')
  },
  {
    path: '/add-driver',
    name: 'AddDriver',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/driver/upsert.vue')
  },
  {
    path: '/driver-view/:id',
    name: 'DriverView',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/driver/view.vue')
  },
  {
    path: '/station-view/:id',
    name: 'StationView',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/station/view.vue')
  },
  {
    path: '/update-driver/:id',
    name: 'UpdateDriver',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/driver/upsert.vue')
  },
  {
    path: '/update-product/:id',
    name: 'UpdateProduct',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/productType/upsert.vue')
  },
  {
    path: '/add-product',
    name: 'AddProduct',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/productType/addNewProduct.vue')
  },
  {
    path: '/LNG-source',
    name: 'LNGSource',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/station/lngSourceList.vue')
  },
  {
    path: '/LNG-customer',
    name: 'LNGCustomer',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/station/lngCustomerList.vue')
  },
  {
    path: '/CNG-source',
    name: 'CNGSource',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/station/cngSourceList.vue')
  },
  {
    path: '/CNG-customer',
    name: 'CNGCustomer',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/station/cngCustomerList.vue')
  },
  {
    path: '/workshop',
    name: 'workshop',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/station/workshopList.vue')
  },
  {
    path: '/add-station/:type',
    name: 'AddStation',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/station/upsert.vue')
  },
  {
    path: '/update-station/:type/:id',
    name: 'UpdateStation',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/station/upsert.vue')
  },
  {
    path: '/orders',
    name: 'Orders',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/list.vue')
  },
  {
    path: '/orders/:tab',
    name: 'FilterOrders',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/list.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/user/profile.vue')
  },
  {
    path: '/profile/:id',
    name: 'ProfileInfo',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/user/profile.vue')
  },
  {
    path: '/add-order',
    name: 'AddOrder',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/upsert.vue')
  },
  {
    path: '/update-order/:id',
    name: 'UpdateOrder',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/upsert.vue')
  },
  {
    path: '/deviate-load/:id',
    name: 'DeviateLoad',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/deviateOrder.vue')
  },
  {
    path: '/initiate-order/:id/:type',
    name: 'InitiateOrder',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/initiateOrder.vue')
  },
  {
    path: '/close-trip/:id',
    name: 'CloseTrip',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/closeTrip.vue')
  },
  {
    path: '/execute-order/:id',
    name: 'ExecuteOrder',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/orderExecute.vue')
  },
  {
    path: '/delivery-note/:id/:type',
    name: 'DeliveryNote',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/deliveryNote.vue')
  },
  {
    path: '/start-trip/:id',
    name: 'StartTrip',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/startTrip.vue')
  },
  {
    path: '/end-trip/:id',
    name: 'EndTrip',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/endTrip.vue')
  },
  {
    path: '/update-ack/:id',
    name: 'updateAck',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/updateAck.vue')
  },
  {
    path: '/order-view/:id',
    name: 'OrderView',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/order/orderView.vue')
  },
  {
    path: '/rtkm/:type',
    name: 'RTKM',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/RTKM/list.vue')
  },
  {
    path: '/add-rtkm/:type',
    name: 'AddRTKM',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/RTKM/upsert.vue')
  },
  {
    path: '/override-requests',
    name: 'overridRequests',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/overrideRequests/requests.vue')
  },
  {
    path: '/update-rtkm/:type/:id',
    name: 'UpdateRTKM',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/RTKM/upsert.vue')
  },
  {
    path: "*", component: () =>
      import('../views/not-found.vue')
  },
  {
    path: '/sourceChange-steps-view',
    name: 'SourceChangeSteps',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../components/SourceChangeSteps.vue')
  },
  {
    path: '/addCustomer-steps-view',
    name: 'AddCustomerSteps',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../components/AddCustomerSteps.vue')
  },
  {
    path: '/update-cascade-type/:id',
    name: 'UpdateCascadeType',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/dbsCascade/addCascadeType.vue')
  },
  {
    path: '/add-cascade-type',
    name: 'AddCascadeType',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/dbsCascade/addCascadeType.vue')
  },
  {
    path: '/cascade-types',
    name: 'CacadeTypes',
    meta: { transition: 'slide-left' },
    component: () =>
      import('../views/dbsCascade/cascadeTypeList.vue')
  },
  {
    path: "/vehicle-summary/:token",
    name: "VehicleSummary",
    meta: { public: true },
    component: () => import("@/views/vehicle/vehicle-summary.vue"),
  },

  ]
})
